<template>
    <v-form>
        <v-card>
            <v-card-title>
                <span class="headline">Choose Sale</span>
            </v-card-title>

            <v-card-text>
                <autocomplete v-model="sale" label="Sale" :rules="rules" item-text="label" item-value="id" :url="'/api/Sales/Autocomplete'" :addForm="saleForm" claim="Sale" />
            </v-card-text>

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="quaternary" text @click="cancel">Cancel</v-btn>
                <v-btn color="quaternary" text @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>
    export default {
        props: [
        ],

        components: {
            autocomplete: () => import('../components/Autocomplete.vue')
        },

        data() {
            return {
                saleForm: () => import('../forms/SaleForm'),
                rules: [v => !!v || 'Purchase is required'],
                sale: null
            }
        },

        methods: {
            save() {
                this.$emit('input', this.sale);
            },
            cancel() {
                this.$emit('cancel');
            }
        }
    };
</script>
